import { lazy } from 'react';

const Support = lazy(() => import('./SupportPage'));

const ProcessorSupportConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'processor/support',
      element: <Support />,
    },
  ],
};

export default ProcessorSupportConfig;
